import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Logger from './services/Logger';
import UiBlocker from './services/UiBlocker';
import ScreenInboxImport from './components/ScreenInboxImport';
import store from './store/inboxApp';
import picsioConfig from '../../../config';
import checkBrowser from './helpers/checkBrowser';
import { showDialog } from './components/dialog';
import * as utils from './shared/utils';
import l10n from './shared/strings';

import '../css/public-sharing.scss';

picsioConfig.access = window.inbox;

try {
  Logger.setUser({ displayName: 'Web user', email: picsioConfig.access.alias });

  /** remove initial spinner from HTML */
  const $initialSpinner = document.getElementById('start-up-spinner');
  if ($initialSpinner) document.body.removeChild($initialSpinner);

  const spinnerStartApp = UiBlocker.block();

  checkBrowser();

  Logger.log('UI', 'InboxStarted', utils.getScreenUrl());
  window.addEventListener('beforeunload', () => {
    Logger.log('User', 'InboxRefreshed', utils.getScreenUrl());
  });

  const isConsentNeeded = window.inbox.visitingConsentEnable;
  if (isConsentNeeded) {
    Logger.log('UI', 'VisitingConsentDialog');
    showDialog({
      title: l10n.DIALOGS.DOWNLOAD_CONSENT.TITLE(window.inbox.visitingConsentTitle),
      text: l10n.DIALOGS.DOWNLOAD_CONSENT.TEXT(window.inbox.visitingConsentMessage),
      textBtnCancel: l10n.DIALOGS.DOWNLOAD_CONSENT.CANCEL_TEXT,
      textBtnOk: l10n.DIALOGS.DOWNLOAD_CONSENT.OK_TEXT,
      onOk: () => {
        Logger.log('User', 'VisitingConsentDialogConfirm');
      },
      onCancel: () => {
        Logger.log('User', 'VisitingConsentDialogReject');
        const consentUrl = utils.prepareUrlForConsent(window.inbox.alias);
        window.open(consentUrl, '_self');
      },
    });
  }

  spinnerStartApp.destroy();

  /** Render Inbox app */
  const container = document.querySelector('.wrapperPicsioApp');
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <ScreenInboxImport />
      <ToastContainer
        position="bottom-right"
        autoClose={10000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnHover
        pauseOnFocusLoss
        draggable
      />
    </Provider>,
  );
} catch (err) {
  const text = l10n.APP_START.DEFAULT_ERROR;
  UiBlocker.unblock();
  showDialog({
    title: 'Error',
    text,
    textBtnOk: null,
    textBtnCancel: null,
  });
  Logger.error(new Error('Inbox start failed'), { error: err }, [
    'StartInboxFailed',
    { errorMessage: (err && err.message) || 'NoMessage' },
  ]);
}
